export const capitalize = (s: string) => {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const multipleKeys = (keys: string[], selectedKey: string) =>
  keys.includes(selectedKey) ? selectedKey : keys[0]
